import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { userStore } from "../../stores";

const OIDCRedirect = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const originalPath = sessionStorage.getItem("originalPath");
    sessionStorage.removeItem("originalPath");
    navigate(originalPath || "/");
  }, [auth.isAuthenticated]);

  return <div>Authenticating...</div>;
};

export { OIDCRedirect };
export default OIDCRedirect;
